import { FC, useMemo } from 'react';
import { Box, Typography, TypographyProps } from '@mui/material';
import {
    ArrowUpward as ArrowUpwardIcon,
    ArrowDownward as ArrowDownwardIcon,
    Remove as RemoveIcon,
} from '@mui/icons-material';

import Row from '../Row';
import theme from '../../theme';

interface MetricChangeLabelProps {
    label?: string;
    direction?: 'up' | 'down' | 'center';
    inverseColor?: boolean;
    variant?: TypographyProps['variant'];
}

const MetricChangeLabel: FC<MetricChangeLabelProps> = ({
    label,
    direction,
    inverseColor,
    variant = 'body1',
}): React.JSX.Element => {
    const metricColor = useMemo((): string => {
        if (direction === 'center') {
            return 'action';
        }

        if (inverseColor) {
            return direction === 'down' ? theme.palette.error.main : theme.palette.success.main;
        }

        return direction === 'up' ? theme.palette.success.main : theme.palette.error.main;
    }, [inverseColor, direction]);

    return (
        <Row gap={0.5} width="auto">
            {direction === 'up' && <ArrowUpwardIcon color={inverseColor ? 'error' : 'success'} fontSize="small" />}
            {direction === 'down' && <ArrowDownwardIcon color={inverseColor ? 'success' : 'error'} fontSize="small" />}
            {direction === 'center' && <RemoveIcon color="action" fontSize="small" />}

            <Typography variant={variant} color="text.primary">
                <Box component="span" sx={{ color: metricColor }}>
                    {label}
                </Box>
            </Typography>
        </Row>
    );
};

export default MetricChangeLabel;
